const knownFields = ["transactions", "errors"] as const;

const isArray = <T>(v: unknown): v is T[] => Array.isArray(v);

export const dropUnsampled: FilterFn = (payload) => {
  const ttt = payload[knownFields[0]];

  /*                                */
  if (!isArray<{ sampled?: boolean }>(ttt)) return payload;

  /*                              */
  payload.transactions = ttt.filter((t) => t.sampled !== false);

  /*                                                            */
  if (knownFields.every((f) => isArray(payload[f]) && payload[f].length === 0)) return false;

  return payload;
};
